'use client'

import { ChevronLeft, ChevronRight } from 'lucide-react'

interface ScrollControlsProps {
  scrollContainerId: string
}

export function ScrollControls({ scrollContainerId }: ScrollControlsProps) {
  const scroll = (direction: 'left' | 'right') => {
    const container = document.getElementById(scrollContainerId)
    if (!container) return

    const scrollAmount = 500
    const scrollTo = direction === 'left'
      ? container.scrollLeft - scrollAmount
      : container.scrollLeft + scrollAmount

    container.scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    })
  }

  return (
    <>
      <button
        onClick={() => { scroll('left') }}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
        aria-label="Scroll left"
      >
        <ChevronLeft className="h-6 w-6" />
      </button>

      <button
        onClick={() => { scroll('right') }}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 p-2 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
        aria-label="Scroll right"
      >
        <ChevronRight className="h-6 w-6" />
      </button>
    </>
  )
}